import IModel from "../model/applicationForm/IApplicationForm";
import IRequest from "../dto/IApplicationRequest";
import Request from "../dto/ApplicationRequest";
import IApplication from "../model/IApplication";
import Application from "../model/Application";
import Financing from "../dto/Financing";
import CustomerMapper from "@/module/main/service/CustomerMapperV2";
import BaseMapperV2 from "@/module/main/service/BaseMapperV2";
import ApiName from "@/module/api/service/ApiNameEnum";

class ApplicationV2Mapper extends BaseMapperV2 {

    readonly VERSION: string = 'v2';
    readonly API_NAME: string = ApiName.FINANCING;

    public toCreateRequest(application: IModel): IRequest {
        return new Request(
            this.getFinancedSubjectBase(application),
            this.getOriginationContext(application.endpoints),
            new Financing(),
            CustomerMapper.getCustomer(application.customer, application.currency.code)
        );
    }

    public fromResponse(response: any): IApplication {
        let {customerKey, state, stateReason, id, workflowSteps} = response;

        return new Application(customerKey, id, state, stateReason, workflowSteps);
    }
}

export default new ApplicationV2Mapper();
